<app-header></app-header>

<div class="applicationWrapper">
  <router-outlet></router-outlet>
</div>
